import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Documentation from "@/pages/Documentation";
import StaffLogin from "@/pages/StaffLogin";
import StaffDashboard from "@/pages/StaffDashboard";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";
import { CookieBanner } from "@/components/site/CookieBanner";
import { AuthProvider } from "@/lib/auth";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { loadTrackers, trackersAllowed } from "@/lib/consent";
import Success from "@/pages/Success";
import Referral from "@/pages/Referral";

function App() {
  // PostHog and the X pixel moved out of index.html so they can be held back until consent.
  // Outside the EU/EEA/UK trackersAllowed() is true straight away and they load on mount, same
  // as before; inside it, CookieBanner calls loadTrackers() if the visitor accepts.
  useEffect(() => {
    if (trackersAllowed()) loadTrackers();
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/documentation" element={<Documentation />} />
            {/* Belt-and-suspenders: vercel.json 301s /docs server-side, this covers client-side nav too. */}
            <Route path="/docs" element={<Navigate to="/documentation" replace />} />
            <Route path="/staff/login" element={<StaffLogin />} />
            <Route path="/dashboard" element={<StaffDashboard />} />
            <Route path="/success" element={<Success />} />
            <Route path="/referral" element={<Referral />} />
            {/* Anything else. Vercel's SPA fallback serves index.html with a 200, so this is a
                soft 404 as far as crawlers are concerned — the noindex tag NotFound sets is what
                actually keeps it out of search results. */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="bottom-left" />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}
export default App;
